import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'UserTypeCache';

class UserTypeCache extends CacheBase2 {
    /**
     * Replaces the full user-type list in cache.
     * @param {{label: string, value: string}[]} items
     */
    setItems = (items) => {
        this.setCache(items);
    };

    getItems = () => {
        return this.getAll();
    };
}

const userTypeCache = new UserTypeCache();
export default userTypeCache;
